const sponsorsList = [
  "ABC CAPITAL",
  "ACCENDO BANCO",
  "ACTINVER",
  "AFIRME",
  "AKALA",
  "AMERICAN EXPRES",
  "ASP INTEGRA OPC",
  "AUTOFIN",
  "AZTECA",
  "BAJIO",
  "BANAMEX",
  "BANCO FAMSA",
  "BANCO FINTERRA",
  "BANCOMEXT",
  "BANCOPPEL",
  "BANCO S3",
  "BANCREA",
  "BANJERCITO",
  "BANKAOOL",
  "BANK OF AMERICA",
  "BANOBRAS",
  "BANORTE/IXE",
  "BANREGIO",
  "BANSEFI",
  "BANSI",
  "BANXICO",
  "BARCLAYS",
  "BBASE",
  "BBVA BANCOMER",
  "BMONEX",
  "CAJA POP MEXICA",
  "CAJA TELEFONIST",
  "CB INTERCAM",
  "CIBANCO",
  "CI BOLSA",
  "CLS",
  "CoDi Valida",
  "COMPARTAMOS",
  "CONSUBANCO",
  "CREDICAPITAL",
  "CREDIT SUISSE",
  "CRISTOBAL COLON",
  "DEUTSCHE",
  "DONDE",
  "ESTRUCTURADORES",
  "EVERCORE",
  "FINAMEX",
  "FINCOMUN",
  "FOMPED",
  "FONDO (FIRA)",
  "GBM",
  "HDI SEGUROS",
  "HIPOTECARIA FED",
  "HSBC",
  "ICBC",
  "INBURSA",
  "INDEVAL",
  "INMOBILIARIO",
  "INTERCAM BANCO",
  "INVERCAP",
  "INVEX",
  "JP MORGAN",
  "KUSPIT",
  "LIBERTAD",
  "MASARI",
  "MIFEL",
  "MIZUHO BANK",
  "MONEXCB",
  "MUFG",
  "MULTIVA BANCO",
  "MULTIVA CBOLSA",
  "NAFIN",
  "ORDER",
  "OSKNDIA",
  "PAGATODO",
  "PROFUTURO",
  "REFORMA",
  "SABADELL",
  "SANTANDER",
  "SCOTIABANK",
  "SKANDIA",
  "SOFIEXPRESS",
  "STP",
  "TRANSFER",
  "UNAGRA",
  "VALMEX",
  "VALUE",
  "VECTOR",
  "VE POR MAS",
  "VOLKSWAGEN",
];

export default sponsorsList;
